<template>
  <div>
    <b-loading v-if="loading" active :is-full-page="false" />
    <div v-else>

      <div v-for="capper in unconfirmed"
           :key="`unconfirmed-capper-${capper.service}`"
           :class="`${serviceWrapperClasses()}`">
        <available-capper :capper="capper" :confirmed="false" />
      </div>

      <div v-for="capper in cappers"
           :key="`capper-${capper.code}`"
           :class="serviceWrapperClasses()">
        <Capper :capper="capper" />
      </div>

      <div v-for="capper in sortedMore"
           :key="`available-capper-${capper.service}`"
           :class="`${serviceWrapperClasses()} ${unconfirmed && unconfirmed.length ? 'is-hidden' : ''}`">
        <available-capper :capper="capper" confirmed />
      </div>

      <b-modal v-model="showOrderConfirmation" :can-cancel="false" full-screen>
        <div class="box">
          <profile-form @userUpdated="$emit('userUpdated', $event)"
                        :show-pass="false"
                        :title="orderConfirmationTitle"
                        :sub-title="orderConfirmationSubTitle" />
          <div class="buttons is-centered mt-5">
            <button @click="submitWootForm" class="button is-success is-large">Looks Good</button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { serviceWrapperClasses, adjustTSSRiskAmounts, addWriteUpPromo, isThanksPage } from '@/utils/misc';
import { getUserPicks } from '@/utils/api';
import Capper from '@/components/members/Capper';
import AvailableCapper from '@/components/members/AvailableCapper';
import ProfileForm from '@/components/misc/ProfileForm';

export default {
  components: {
    AvailableCapper,
    Capper,
    ProfileForm
  },
  data() {
    return {
      loading: true,
      cappers: [],
      more: [],
      sortedMore: [],
      unconfirmed: [],
      prods: [],
      capperAccess: [],
      picks: [],
      showOrderConfirmation: false,
      showBigPickSnack: false,
      orderConfirmationTitle: process.env.VUE_APP_ORDER_CONFIRMATION_TITLE || 'Congrats on your new purchase!',
      orderConfirmationSubTitle: process.env.VUE_APP_ORDER_CONFIRMATION_SUB_TITLE || 'Please update your preferences below...',
      timeOut: null,
    }
  },
  mounted() {
    getUserPicks()
      .then(async res => {
        if (!res.ok) {

          this.$buefy.toast.open({
            message: 'Login',
            type: 'is-danger'
          });

          return this.$router.push({path: '/login', query: this.$route.query});
        }

        let userInfo = await res.json();
        let promoAdded = false;
        let more = Array.isArray(userInfo.more) ? userInfo.more : [];
        let servicesAccessed = Object.keys(userInfo.capperAccess);

        if (process.env.VUE_APP_HIDE_UNITS) {
          more = more.map(capper => {
            capper.pending = capper.pending.map(pick => {
              pick.risk = 0;
              pick.gain = 0;
              return pick;
            });

            return capper;
          });

          userInfo.picks = userInfo.picks.map(pick => {
            pick.risk = 0;
            pick.gain = 0;
            return pick;
          });
        }

        this.showOrderConfirmation = isThanksPage(this.$route.query);
        this.more = more.filter(capper => {
          if (!('excludedBy' in capper) || !Array.isArray(capper.excludedBy)) {
            return true;
          }

          return !capper.excludedBy.some(service => servicesAccessed.includes(service))
        });
        this.unconfirmed = userInfo.unconfirmed;
        this.prods = userInfo.prods;
        this.capperAccess = userInfo.capperAccess;
        this.picks = userInfo.picks
        // eslint-disable-next-line no-unused-vars
          .map((pick, i, ary) => addWriteUpPromo(pick, ary, this.more, promoAdded, () => {promoAdded = true;}))
          .reduce(this.combineParlayedPicks, []);
        this.cappers = Object.keys(userInfo.capperAccess)
          .filter((capper, i, ary) => {
            let otherServices = ary.filter(otherCapper => capper !== otherCapper);
            let serviceDeets = userInfo.capperAccess[capper];
            let serviceIsExcludedBy = serviceDeets.excludedBy || [];
            let userHasExclusionaryServices = serviceIsExcludedBy.some(service => otherServices.includes(service))

            return !(serviceDeets.isFree && userHasExclusionaryServices);
          })
          .map(this.populateCapper);
        this.sortedMore = this.getSortedMore();

        this.$nextTick().then(() => this.showBigPickSnackIfPossible())
      })
      .finally(() => {
        this.loading = false;
      });
  },
  destroyed() {
    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
  },
  methods: {
    adjustTSSRiskAmounts: adjustTSSRiskAmounts,
    serviceWrapperClasses: serviceWrapperClasses,
    showBigPickSnackIfPossible: async function () {
      let pastEngagement = JSON.parse(localStorage.getItem('engageBiggestPick'));
      let hasNotEngaged = !pastEngagement ? true : (new Date().getTime() - pastEngagement.dateTime) > 1000*60*60*24*2;
      await this.$nextTick();

      let { showOrderConfirmation, showBigPickSnack } = this;

      if (!showOrderConfirmation && showBigPickSnack && hasNotEngaged) {
        this.timeOut = setTimeout(() => {
          this.$buefy.snackbar.open({
            duration: 10000,
            message: 'See my highest unit ' + (process.env.VUE_APP_PICK_LABEL || 'Pick'),
            cancelText: 'No', // COMING OUT IN NEXT BEUFY RELEASE!
            actionText: 'Yes',
            onAction: () => {
              localStorage.setItem('engageBiggestPick', JSON.stringify({dateTime: new Date().getTime()}));

              let capperWithBiggestPick = this.more.find(capper => capper.biggestPick);
              let elId = `available-capper-id-${capperWithBiggestPick?.service}`;
              let el = document.getElementById(elId);

              if (el) {
                el.scrollIntoView({behavior: 'smooth'});
              }
            }
          });
        }, 2500)
      }
    },
    submitWootForm: function () {
      this.showOrderConfirmation = false;
      let formData = new FormData();
      let user = JSON.parse(localStorage.getItem('user'));
      let name = user.name_f + ' ' + user.name_l;
      let { query } = this.$route;
      let wootEndpoint = process.env.VUE_APP_WOOT_ENDPOINT;

      formData.append('name', name);

      ['email', 'street', 'street2', 'city', 'state', 'zip', 'country', 'phone', 'bankroll', 'avg_wager', 'text_alerts']
        .forEach(userAttr => {
          if (!(userAttr in user)) return;

          if (!formData.has(userAttr)) {
            formData.append(userAttr, user[userAttr])
          }
        });

      Object.keys(query).forEach(orderAttr => {
        if (!formData.has(orderAttr) && orderAttr in query) {
          formData.append(orderAttr, query[orderAttr])
        }
      })

      if (wootEndpoint) {
        fetch(wootEndpoint, {
          method: 'POST',
          body: formData
        })
        .then(res => {
          if (!res.ok) {
            console.error(`${res.status}: ${res.statusText}`);
          } else {
            console.log('new purchase confirmed');
          }
        });
      }

      this.$router.replace({query: null})
    },
    combineParlayedPicks: function (p,c, i, ary) {
      let { finalizeParlayRisk } = this;
      let picksParams = new URLSearchParams(c.instructions);

      if (!picksParams.has('parlayid')) {
        p.push(c);
        return finalizeParlayRisk(p, i === ary.length - 1);
      }

      let parlay = p.find(pick => {
        let isParlayWithBets = pick.type === 'Parlay' && Array.isArray(pick.bets) && pick.bets.length
        let isSameService = pick.service === c.service;

        if (!isParlayWithBets || !isSameService) return false;

        let parlayId = new URLSearchParams(pick.bets[0].instructions).get('parlayid');

        return parlayId === picksParams.get('parlayid');
      });

      if (parlay) {
        parlay.bets.push(c);
        parlay.dateTime = parlay.dateTime > c.dateTime ? c.dateTime : parlay.dateTime;
        parlay.gain *= 1 + (c.gain/c.risk);
        p.splice(-2, 0, c);
        return finalizeParlayRisk(p, i === ary.length - 1);
      }

      let {title, service, dateTime, risk, gain, id} = c;

      p.push(c);

      p.push({
        type: 'Parlay',
        bets: [c],
        title,
        service,
        dateTime,
        risk,
        id: `${id}-${picksParams.get('parlayid')}`,
        gain: (risk * (1 + (gain/risk))),
        instructions: picksParams.get('instructions') || ''
      });

      return finalizeParlayRisk(p, i === ary.length - 1);
    },
    populateCapper: function (capperCode) {
      let {picks, capperAccess, adjustTSSRiskAmounts} = this;
      let servicePicks = picks
        .filter(pick => {
          let isStale = pick.dateTime < new Date().getTime();
          let hideClosed = capperAccess[capperCode].hideClosedPicks;
          let shouldHidePick = isStale && hideClosed;

          return pick.service === capperCode && !shouldHidePick;
        });
      let serviceTitle = capperAccess[capperCode].title;
      let isTSS = capperAccess[capperCode].isTSS;

      return {
        title: serviceTitle,
        picks: isTSS ? adjustTSSRiskAmounts(servicePicks) : servicePicks,
        code: capperCode
      };
    },
    finalizeParlayRisk: function (combinedPicks, isLastPick) {
      if (!isLastPick) {
        return combinedPicks;
      }

      return combinedPicks
        .map(pick => {
          if (pick.type !== 'Parlay') {
            return pick;
          }

          pick.gain = parseFloat((pick.gain - pick.risk).toFixed(2));

          return pick;
        });
    },
    getSortedMore: function () {
      let sortedPickRisk = [...this.picks].sort((a,b) => b.risk - a.risk);
      let sortedPendingRisk = this.more.flatMap(capper => capper.pending).sort((a,b) => b.risk - a.risk);
      let biggestPick = sortedPickRisk[0]?.risk || 0;
      let biggestPending = sortedPendingRisk[0]?.risk;
      let userMissingOut = biggestPending && biggestPick < biggestPending && !process.env.VUE_APP_HIDE_UNITS;

      let sorted = [...this.more]

        .map(capper => {
          // User already has the biggest pick
          if (!userMissingOut) {
            return capper;
          }

          // This capper owns the biggest pick and needs a reference to it
          let ownsBiggestPending = capper.pending.find(pending => pending.id === sortedPendingRisk[0]?.id);

          if (ownsBiggestPending && ownsBiggestPending.dateTime > new Date().getTime() && ownsBiggestPending.risk >= 3) {
            capper.biggestPick = ownsBiggestPending;
            ownsBiggestPending.isBiggest = true;
            this.showBigPickSnack = true;
          }

          return capper;
        })
        .sort((a,b) => {
          // Sort by record length first
          let aRecordLength = a.r.length;
          let bRecordLength = b.r.length;
          let hasSameRecordLength = aRecordLength === bRecordLength;

          if (!hasSameRecordLength) return bRecordLength - aRecordLength;

          // Sort by record strike rate second...
          let aRate = a.r.filter(result => result.isWinner).length / (a.r.filter(result => result.isWinner !== null).length || 1);
          let bRate = b.r.filter(result => result.isWinner).length / (b.r.filter(result => result.isWinner !== null).length || 1);
          let areSame = aRate === bRate;

          if (!areSame) return bRate - aRate;

          // Sort by pending games next
          let aPendingGames = a.pending.filter(game => game.dateTime > new Date().getTime()).length;
          let bPendingGames = b.pending.filter(game => game.dateTime > new Date().getTime()).length;

          areSame = aPendingGames === bPendingGames;

          if (!areSame) return bPendingGames - aPendingGames;

          // Sort by sum of payment link prices.
          let aValue = a.paymentLinks.reduce((p,c) => {
            return (c.price || 0) + p;
          }, 0);

          let bValue = b.paymentLinks.reduce((p,c) => {
            return (c.price || 0) + p;
          }, 0);

          return bValue - aValue;
        });

      // decorate the highest sorted service that has coupon for one of its payment links
      sorted.some((capper, i) => {
        let linkWithCoupon = capper.paymentLinks.find(link => link.coupon);
        if (linkWithCoupon) {
          sorted[i].couponPromo = linkWithCoupon;
          return true;
        }

        return false;
      });

      return sorted
          // Add dynamic upsell flows to all payment links
          .map((capper, i, cappers) => {
            let eligibleServices = cappers.filter(service => {
              return capper.service !== service.service &&
                  service.cbfid &&
                  service.cbfidIsActive
            });

            if (!eligibleServices.length) return capper;

            capper.paymentLinks = capper.paymentLinks.map(link => {
              let parsedLink = link.url.split('?');
              let currentParams = new URLSearchParams(parsedLink[1]);
              let linkItemNo = currentParams.get('cbitems');
              let eligibleUpsells = eligibleServices.filter(service => service.cbfidItem !== linkItemNo);

              if (!eligibleUpsells.length) return link;

              currentParams.set('cbfid', eligibleUpsells[0].cbfid);

              link.url = `${parsedLink[0]}?${currentParams.toString()}`;

              return link;
            });

            return capper;
          });
    }
  }
}
</script>
